import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { isRef as _isRef, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26def42a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addition" }
const _hoisted_2 = { class: "rel" }
const _hoisted_3 = {
  class: "abs clear-add",
  style: {"right":"0","top":"-6px"}
}
const _hoisted_4 = { class: "text-rt mt_10 commit submit-btn" }
const _hoisted_5 = {
  key: 0,
  class: "primary mtrl-tip",
  style: {"font-size":"12px","line-height":"18px"}
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "btn-content" }

import { ref, watch, computed, onMounted } from 'vue'
import AdtLoop from './components/AdtLoop.vue'
import AdtTemplate from './components/AdtTemplate.vue'
import AdtList from './components/AdtList.vue'
import AdtMtrl from './components/AdtMtrl.vue'
import { t } from '@/plugins/i18n'
import useEdited from '@/util/useEdited'
// import { confirmEdit } from '@/util/useConfirm'
import { adt, gpAdt, adtFn } from '@/util/useData'
import { useWrap } from '@/util/useCheckMap'
import { ElMessageBox, ElMessage } from 'element-plus'
import store, { isJA, isKO, isEN, isD2C, getWarehouseCode, getWarehouseByCountry } from '@/store'
import { setAdt } from '@/util/calcAdt'
import useUtil from './index'
import WashingMarkSelect from './components/WashingMarkSelect.vue'
import confirmDialog from '@/components/common/ConfirmDialog'
import { COUNTRY } from '@/global'


export default /*#__PURE__*/_defineComponent({
  props: ['list', 'isGroup', 'amount', 'isAssociate', 'proxy', 'noAdt', 'additionMerge', 'hideAdtLoop', 'needChangeSize', 'isBackSku', 'loading', 'noSpot', 'isCalculator', 'isConfirmKey', 'hiddenWashSku', 'countryCode', 'mustAdditionId', 'choiceCost', 'isBatchEdit'],
  emits: ['update:list', 'commit', 'beforeClose'],
  async setup(__props, { expose, emit }) {

let __temp: any, __restore: any

const props = __props
const washAdditionId = isJA() ? 1 : isKO() ? 69 : 136
const washingMrakSelectRef = ref()
const {
  additionSort,
  sortAdd,
  scrollView
} = useUtil()
// noAdt 不需要附加项 isAssociate 创建关联商品 isBackSku 回显sku needChangeSize 是否需要尺码更改附加项显示
// list 附加项列表
// isGroup 是否为组合主商品编辑附加项 组合主商品不允许选择抽检
// noSpot 不允许选择抽检
// isCalculator 是否成本计算器-成本计算器获取附加项，非会员取最高等级会员附加项计算
// isConfirmKey 是否通过confirmWashedlabelSpecification弹窗
// hiddenWashSku  是否隐藏sku
// countryCode 国家 CN KR
// mustAdditionId 必选附加项
// isBatchEdit 是否批量编辑 - 仅控制是否展示附加项模版选择


const [adtMap, wrap] = useWrap(props.list ?? [], 'additionId')
const refMap: any = {}
const propsAdtFormat = (additionMerge: any) => {
  return additionMerge.map((v: any) => {
    const t1 = { ...v }
    if (adtMap[t1.additionId]) {
      // 附加项列表添加已配置的辅料sku
      t1.ingredientsSku = adtMap[t1.additionId].ingredientsSku
      // additionExtraName
      if (t1.userFill) {
        t1.additionExtraName = adtMap[t1.additionId].additionExtraName
      }
      // 原始数据源拷贝值
      adtMap[t1.additionId] = JSON.parse(JSON.stringify(t1))
      // 关联附加项列表
      refMap[t1.additionId] = t1
    }

    // if (props.noSpot && t1.spotCheckSupport === 1) {
    //   // noSpot默认为全检 并修改spotCheckSupport 不需要弹窗
    //   t1.spotCheckSupport = 0
    //   t1.spotCheckFlag = 0
    // }
    // 返回重新生成的附加项列表
    return t1
  })
}
const isLogin = computed(() => store.getters.isLogin)
const adtApi: any = computed(() => {
  if ((props.isCalculator || !isLogin.value)) {
    return () => props.isGroup ? gpAdt(1) : adtFn(1)
  }
  return props.isGroup ? (a: string) => gpAdt(0, a) : adt
})
const adtRes: any = ref([])
const warehouseCode = getWarehouseByCountry(props.countryCode)
adtRes.value = props.additionMerge ? propsAdtFormat(props.additionMerge) : (
  ([__temp,__restore] = _withAsyncContext(() => adtApi.value(warehouseCode).then((data: any) => {
  return data.productAdditionList.map((v: any) => {
    const t1 = { ...v }
    if (adtMap[t1.additionId]) {
      // 附加项列表添加已配置的辅料sku
      t1.ingredientsSku = adtMap[t1.additionId].ingredientsSku
      // additionExtraName
      if (t1.userFill) {
        t1.additionExtraName = adtMap[t1.additionId].additionExtraName
      }
      if (t1.spotCheckSupport === 1) {
        t1.spotCheckFlag = adtMap[t1.additionId].spotCheckFlag
        t1.spotCheckRatio = adtMap[t1.additionId].spotCheckRatio || ''
      }
      if (t1.additionCode === 1) {
        t1.washedlabelAdditionId = adtMap[t1.additionId].washedlabelAdditionId
        t1.washedlabelName = adtMap[t1.additionId].washedlabelName
        t1.washedlabelSpecification = adtMap[t1.additionId].washedlabelSpecification
        t1.confirmWashedlabelSpecification = adtMap[t1.additionId].confirmWashedlabelSpecification
      }
      // 原始数据源拷贝值
      adtMap[t1.additionId] = JSON.parse(JSON.stringify(t1))
      // 关联附加项列表
      refMap[t1.additionId] = t1
    }
    // 如果 needChangeSize === 2 则判断是否需要禁用
    if (props.needChangeSize === 2 && t1.additionCode === 63) {
      t1.disabled = true
      t1.additionMsg = props.proxy && (props.proxy?.platformItemSku?.productType || props.proxy?.productType) ? '' : t('请创建关联关系后再选择')
    }

    // if (props.noSpot && t1.spotCheckSupport === 1) {
    //   // noSpot默认为全检 并修改spotCheckSupport 不需要弹窗
    //   t1.spotCheckSupport = 0
    //   t1.spotCheckFlag = 0
    // }
    // 返回重新生成的附加项列表
    return t1
  })
}))),
  __temp = await __temp,
  __restore(),
  __temp
)

// 删除已不存在的附加项
// Object.keys(adtMap).forEach((key: any) => {
//   const k = adtRes.value.find((v: any) => v.additionConfigId === adtMap[key].additionConfigId)
//   if (!k) delete adtMap[key]
// })



const visible = ref(true)
const [data, commit, clear] = useEdited({ adtMap }, () => {
  const additionList = Object.values(additionSort.value).map((v: any) => ({
    ...v
  }))
  const fn = async () => {
    if (additionList.length === 0 && !(noNeed.value)) {
      error.value = true
      ElMessage.warning(t('请选择附加项'))
      return
    }
    if (noNeed.value) {
      emit('commit', 1)
    } else {
      // 如果选择的水洗标需要校验是否选择了水洗标和客户商品规格
      const washAdt = additionList.find((v) => v.additionCode === 1)
      let washForm = null
      // 批量修改不需要选择水洗标->购物车批量编辑需要选择水洗标模版
      if (washAdt && (props.proxy?.productSku || props.isBatchEdit) && washingMrakSelectRef.value) {
        washForm = await washingMrakSelectRef.value?.check()
        console.log('washForm', washForm)
        if (!washForm) {
          scrollView(650)
          return
        }
      }
      const isOneProduct = props.proxy?.buyQuantity === 1
      additionList.forEach((item) => {
        // 购物车当数量为1时选择可以抽检的附加项默认全检
        if (isOneProduct && item.spotCheckSupport === 1) {
          item.spotCheckFlag = 0
          item.spotCheckRatio = ''
        } else {
          item.spotCheckFlag = item.spotCheckRatio && item.spotCheckFlag === 1 ? 1 : 0
        }
        if (item.additionCode === 1 && (props.proxy?.productSku || props.isBatchEdit)) {
          item.washedlabelAdditionId = washForm?.washedlabelAdditionId
          item.washedlabelSpecification = washForm?.washedlabelSpecification
          item.washedlabelName = washForm?.washedlabelName
        }
      })
      console.log('additionList', additionList)
      emit('commit', additionList)
    }
    clear()
    visible.value = false
  }
  if (props.isAssociate && additionList.length === 0) {
    // 关联商品内部需要 没有选择附加项时提示
    ElMessageBox.confirm(`<div>検品用オプション選択されてません</div>
    検品作業を不要で発送してもよろしいでしょうか？`, 'ご確認下さい', {
      confirmButtonText: t('需要'),
      cancelButtonText: t('不需要'),
      type: 'warning',
      dangerouslyUseHTMLString: true
    }).then(fn)
  } else {
    fn()
  }
})
// 重新赋值为关联的引用值
data.adtMap = refMap

const w = wrap(data.adtMap)
const changeAdt = (...rest: any) => {
  if (props.mustAdditionId?.includes(rest[0]?.additionCode) && !rest[1]) {
    return
  }
  // 选择水洗标自动下滑选择客户商品规格
  if (rest[1] && rest[0].additionCode === 1) {
    scrollView(650)
  }
  sortAdd(rest[0], rest[1])
  noNeed.value = false
  error.value = false
  w(...rest)
}

additionSort.value = Object.values(adtMap)
const adtListRef = ref()
const setdefault = async (items: any, noAdditionalFlag: number) => {
  noNeed.value = noAdditionalFlag === 1
  error.value = false
  const { adtMap } = data
  Object.keys(adtMap).forEach((k) => delete adtMap[k])
  items.forEach((v: any) => {
    adtRes.value.forEach((i: any) => {
      // // 赋值时先清空禁用状态
      delete i.disabled
      if (i.additionId === v.additionId) {
        // 选中
        if (i.spotCheckSupport === 1) {
          i.spotCheckFlag = v.spotCheckFlag
          i.spotCheckRatio = v.spotCheckRatio
        }
        adtMap[v.additionId] = {
          ...i,
          ...v,
          ingredientStatus: i.ingredientStatus,
          // 保留原先附加项configid
          additionConfigId: i.additionConfigId
        }
        adtListRef.value.linkageAddition(true, adtMap[v.additionId])
      } else {
        // 抽检没有选中的需要转回全检抽检比例置空
        if (i.spotCheckSupport === 1 && !adtMap[i.additionId]) {
          i.spotCheckFlag = 0
          i.spotCheckRatio = ''
        }
      }
    })
  })
  additionSort.value = Object.values(adtMap)
  // 如果存在辅料的附加项则滚动到底部
  if (additionSort.value.filter((i: any) => i.ingredientStatus).length > 0) {
    scrollView()
  }
}

const cancel = () => {
  confirmEdit(
    () => (
      emit('beforeClose')
    ),
    () => { }
  )
}
const confirmEdit = (ok: () => void, cancel: () => void): void => {
  if (store.getters.editing) {
    ElMessageBox.confirm(t('当前页面的修改内容未保存，是否离开'), t('提示'), {
      confirmButtonText: t('确定'),
      cancelButtonText: t('取消'),
      type: 'warning'
    })
      .then(() => {
        store.commit('status/editing', false)
        ok()
      })
      .catch(cancel)
  } else {
    if (props.isAssociate) {
      // 关联商品内部需要
      ElMessageBox.confirm(t('商品附加项要保存吗'), t('提示'), {
        confirmButtonText: t('需要'),
        cancelButtonText: t('不需要'),
        type: 'warning'
      })
        .then(() => {
          ok()
        })
        .catch(cancel)
    } else {
      ok()
    }
  }
}

const error = ref(false)
const noNeed = ref(Object.keys(refMap).length > 0 ? false : !!(props.proxy?.noAdditionalFlag))
const handleNoNeed = () => {
  additionSort.value = []
  error.value = false
  adtRes.value.forEach((i: any) => {
    // 重置抽检配置
    if (i.spotCheckSupport === 1) {
      i.spotCheckRatio = ''
      i.spotCheckFlag = 0
    }
  })
  Object.values(data.adtMap).forEach((v: any) => {
    w(v, false)
    // 取消勾选
    adtListRef.value.linkageAddition(false, v)
  })
}
let remake: any = null
remake = (v: any) => v
const reset = () => {
  const data = props.proxy
  if (data.productCategoryFrontendNdId) {
    setAdt(data.productCategoryFrontendNdId, 'value').then(async res => {
      // 清空禁用状态
      adtRes.value.forEach((i: any) => {
        delete i.disabled
      })
      setdefault(await remake(res.value), res.noAdditionalFlag)
    })
  }
}

const closeImg = ref()
closeImg.value = require('@/assets/image/icon/close.svg')
// 是否需要弹水洗标二次确认弹窗
const isConfirmWash = ref(false)
onMounted(() => {
  if (data.adtMap[washAdditionId] && isJA()) {
    // 选择
    // 购物车根据confirmWashedlabelSpecification 弹窗 其他根据 washedlabelSpecification 是否为空弹窗
    isConfirmWash.value = props.isConfirmKey ? data.adtMap[washAdditionId].confirmWashedlabelSpecification !== 1 : !data.adtMap[washAdditionId].washedlabelSpecification
    if (isConfirmWash.value) {
      scrollView(650)
    }
    // 如果没有选择
  }
})

expose({
  confirmEdit
})
// 第一次回显触发弹窗关闭
clear()

// 是否选择辅料
const isMtrl = computed(() => {
  return Object.values(data.adtMap).filter((v: any) => v.ingredientStatus)?.length > 0
})


return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.hideAdtLoop && !__props.isGroup)
        ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(AdtTemplate, {
                type: "1",
                adt: adtRes.value,
                onSetdefault: setdefault,
                onExpose: _cache[0] || (_cache[0] = (e) => (_isRef(remake) //@ts-ignore
 ? remake.value = e : remake = e)),
                countryCode: __props.countryCode
              }, null, 8, ["adt", "countryCode"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "historyAdt"),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(), _createBlock(_Suspense, null, {
          default: _withCtx(() => [
            _createVNode(AdtList, {
              onChange: _cache[2] || (_cache[2] = e => changeAdt(...e)),
              adt: adtRes.value,
              "adt-map": _unref(data).adtMap,
              isAssociate: __props.isAssociate,
              product: __props.proxy,
              needChangeSize: __props.needChangeSize,
              isBackSku: __props.isBackSku,
              ref: (_value, _refs) => {
                _refs['adtListRef'] = _value
                adtListRef.value = _value
              },
              mustAdditionId: __props.mustAdditionId,
              noSpot: __props.noSpot,
              choiceCost: __props.choiceCost
            }, _createSlots({ _: 2 }, [
              (!__props.noAdt)
                ? {
                    name: "noNeedAddition",
                    fn: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_radio, {
                          modelValue: noNeed.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((noNeed).value = $event)),
                          label: true,
                          style: {"font-weight":"600","margin-right":"0"},
                          onChange: handleNoNeed
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _withDirectives(_createElementVNode("div", { style: {"color":"#FF3C3C","font-size":"12px"} }, _toDisplayString(_unref(t)('附加项验证')), 513), [
                          [_vShow, error.value]
                        ])
                      ])
                    ])
                  }
                : undefined
            ]), 1032, ["adt", "adt-map", "isAssociate", "product", "needChangeSize", "isBackSku", "mustAdditionId", "noSpot", "choiceCost"])
          ]),
          _: 1
        })),
        (((__props.proxy?.productSku || __props.isBatchEdit)) && _unref(isLogin) && !__props.hiddenWashSku)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_unref(data).adtMap?.[_unref(washAdditionId)])
                ? (_openBlock(), _createBlock(WashingMarkSelect, {
                    key: 0,
                    ref: (_value, _refs) => {
                      _refs['washingMrakSelectRef'] = _value
                      washingMrakSelectRef.value = _value
                    },
                    addition: _unref(data).adtMap?.[_unref(washAdditionId)],
                    product: __props.proxy,
                    isBatchEdit: __props.isBatchEdit
                  }, null, 8, ["addition", "product", "isBatchEdit"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_unref(isLogin) && __props.countryCode !== _unref(COUNTRY).KR)
          ? (_openBlock(), _createBlock(AdtMtrl, {
              key: 1,
              "adt-map": _unref(data).adtMap,
              sort: _unref(additionSort),
              countryCode: __props.countryCode
            }, null, 8, ["adt-map", "sort", "countryCode"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_unref(isMtrl) && __props.countryCode !== _unref(COUNTRY).KR)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", {
              innerHTML: _unref(t)('客户资材必须得提前先下好，保存在仓库，否则无法对应').split('\n').map(v => `<span>${v}</span>`).join('<br/>')
            }, null, 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        (__props.proxy?.productCategoryFrontendNdId)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "default",
              onClick: reset
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('一键配置店铺配置商品附加项')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          type: "default",
          onClick: cancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _unref(commit),
          loading: __props.loading
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ])
    ])
  ], 64))
}
}

})